/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    url: '/',
    name: 'Inicio',
    slug: 'home',
    icon: 'HomeIcon'
  },
  // {
  //   url: "/page2",
  //   name: "Page 2",
  //   slug: "page2",
  //   icon: "FileIcon"
  // },
  /*{
    url: '/casos',
    name: 'Casos',
    slug: 'casos',
    icon: 'FileTextIcon'
  },*/
  {
    //url: null,
    url: '/reportes/casos',
    name: 'Reporte',
    icon: 'FileTextIcon'
    /*submenu:
    [
      {
        url: '/:nameCompany/reportes/casos_cerrados',
        name: 'Casos cerrados',
        slug: 'reportes-casos-cerrados'
      }
    ]*/
  },
  {
    //url: null,
    url: '/configuraciones',
    name: 'Configuraciones',
    icon: 'SettingsIcon'
    /*submenu:
    [
      {
        url: '/:nameCompany/reportes/casos_cerrados',
        name: 'Casos cerrados',
        slug: 'reportes-casos-cerrados'
      }
    ]*/
  }
  // {
  //   url: '/indicadores',
  //   name: 'Indicadores',
  //   slug: 'indicadores',
  //   icon: 'BarChart2Icon'
  // }
]
